import * as React from "react";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";
import DataService from "services/DataService";
import { useUser } from "context/userContext";
import DataTable from "react-data-table-component-footer";
import SortIcon from "@material-ui/icons/ArrowDownward";
import Card from "@material-ui/core/Card";
import constants from "../../constants/Report/reports.js";
import "./reports.css";
import Button from "components/CustomButtons/Button.js";
import { TextField } from "@material-ui/core";
// function createData(name, calories, fat, carbs, protein) {
//   return { name, calories, fat, carbs, protein };
// }

export default function Report() {
  const { credential, language } = useUser();
  const [rows, setRows] = React.useState([]);
  const [totalGrammar, setTotalGrammar] = React.useState(0);
  const [totalMachine, setTotalMachine] = React.useState(0);
  const [lastUsers, setLastUsers] = React.useState(30);

  React.useEffect(() => {
    async function fetch() {
      const headers = {
        Authorization: credential,
      };
      const response = await DataService.reports({
        headers,
      });
      let totalGramm = 0;
      let totalMachi = 0;
      let array = [];
      for (let data of response.data) {
        totalGramm += data.numberOfGrammars;
        totalMachi += data.numberOfMachines;
        if (data.lastAccess != undefined) {
          data.lastAccess = new Date(data.lastAccess).toLocaleDateString(
            "pt-BR"
          );
        }
        array.push(data);
      }
      const fakeData = {
        name: constants.generalTotal[language],
        email: "",
        numberOfGrammars: totalGramm,
        numberOfMachines: totalMachi,
      };
      setTotalGrammar(totalGramm);
      setTotalMachine(totalMachi);
      console.log(fakeData);
      setRows(array);
    }
    fetch();
  }, []);

  const buscar = async () => {
    const headers = {
      Authorization: credential,
    };
    const response = await DataService.limitedReports(
      {
        headers,
      },
      lastUsers
    );

    let totalGramm = 0;
    let totalMachi = 0;
    let array = [];
    for (let data of response.data) {
      totalGramm += data.numberOfGrammars;
      totalMachi += data.numberOfMachines;
      array.push(data);
    }
    const fakeData = {
      name: constants.generalTotal[language],
      email: "",
      numberOfGrammars: totalGramm,
      numberOfMachines: totalMachi,
    };
    setTotalGrammar(totalGramm);
    setTotalMachine(totalMachi);
    console.log(fakeData);
    setRows(array);
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "72px", // override the row height
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
        display: "flex",
        justifyContent: "center",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
        display: "flex",
        justifyContent: "center",
      },
    },
  };

  const columns = [
    {
      id: 1,
      name: constants.name[language],
      selector: (row) => row.name,
      sortable: true,
      reorder: true,
    },
    {
      id: 2,
      name: constants.email[language],
      selector: (row) => row.email,
      sortable: true,
      reorder: true,
    },
    {
      id: 3,
      name: constants.lastAccess[language],
      selector: (row) => row.lastAccess,
      sortable: true,
      reorder: true,
    },
    {
      id: 4,
      name: constants.grammarTotal[language],
      selector: (row) => row.numberOfGrammars,
      sortable: true,
      reorder: true,
    },
    {
      id: 5,
      name: constants.machineTotal[language],
      selector: (row) => row.numberOfMachines,
      sortable: true,
      right: true,
      reorder: true,
    },
  ];
  const footer = {
    name: constants.generalTotal[language],
    email: "",
    numberOfGrammars: totalGrammar,
    numberOfMachines: totalMachine,
  };
  return (
    <div className="container">
      <div className="search">
        <div className="input-search">
          <TextField
            id="number-users"
            placeholder={constants.lastUsers[language]}
            onChange={(el) => {
              setLastUsers(el.target.value);
            }}
            value={lastUsers}
          />
        </div>
        <Button onClick={buscar} color="success">
          {constants.search[language]}
        </Button>
      </div>
      <Card className="card">
        <DataTable
          columns={columns}
          data={rows}
          footer={footer}
          title={constants.report[language]}
          // columns={columns}
          // data={rows}
          defaultSortFieldId={1}
          sortIcon={<SortIcon />}
          // // selectableRows
          customStyles={customStyles}
          pagination
        />
      </Card>
    </div>
  );
}
